/* lePelou Produktseite ab 10/26 – Interaktion fuer lp-Abschnitte */
(function(){
  if (window.lpPdpInit) return; window.lpPdpInit = true;
  function featPick(root, i){
    root.querySelectorAll('.lp-list button').forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.i === i ? 'true' : 'false'); });
    root.querySelectorAll('.lp-view').forEach(function(v){ v.hidden = v.dataset.view !== (i || '0'); });
    var back = root.querySelector('.lp-back'); if (back) back.hidden = !i;
  }
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t.closest) return;
    var pick = t.closest('.lp-pin, .lp-list button');
    if (pick) { featPick(pick.closest('.lp-feat'), pick.dataset.i); return; }
    var back = t.closest('.lp-back');
    if (back) { featPick(back.closest('.lp-feat'), ''); return; }
    var tg = t.closest('.lp-toggle');
    if (tg) { var c = tg.closest('.lp-card'); var o = !c.classList.contains('is-open'); c.classList.toggle('is-open', o); tg.setAttribute('aria-expanded', o ? 'true' : 'false'); return; }
    var nav = t.closest('.lp-nav button');
    if (nav) { var tr = nav.closest('.lp-sec').querySelector('.lp-track'); var card = tr.querySelector('.lp-card'); tr.scrollBy({ left: Number(nav.dataset.dir) * (card.offsetWidth + 8), behavior: 'smooth' }); return; }
    var mute = t.closest('.lp-mute');
    if (mute) { var v = mute.parentNode.querySelector('video'); if (v) { v.muted = !v.muted; mute.textContent = v.muted ? 'Ton an' : 'Ton aus'; } }
  });
  function bars(){
    document.querySelectorAll('.lp-track').forEach(function(tr){
      var th = tr.parentNode.querySelector('.lp-bar i'); if (!th) return;
      var max = tr.scrollWidth - tr.clientWidth; var w = tr.clientWidth / tr.scrollWidth * 100;
      th.style.width = w + '%'; th.style.left = (max > 0 ? tr.scrollLeft / max * (100 - w) : 0) + '%';
    });
  }
  document.addEventListener('scroll', function(e){ if (e.target.classList && e.target.classList.contains('lp-track')) bars(); }, true);
  window.addEventListener('resize', bars);
  /* Lieferzeitraum: Fertigung (Kalendertage) + Versand (Werktage Mo-Fr) */
  function addWork(d, n){ while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function eta(){
    var M = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
    document.querySelectorAll('[data-lp-eta]').forEach(function(el){
      var p = el.dataset.lpEta.split(',').map(Number);
      var a = new Date(); a.setDate(a.getDate() + p[0]); addWork(a, p[2]);
      var b = new Date(); b.setDate(b.getDate() + p[1]); addWork(b, p[3]);
      el.textContent = a.getMonth() === b.getMonth() ? a.getDate() + '. und ' + b.getDate() + '. ' + M[b.getMonth()] : a.getDate() + '. ' + M[a.getMonth()] + ' und ' + b.getDate() + '. ' + M[b.getMonth()];
    });
  }
  /* Rabatt in Prozent neben dem Preis (immer aus den echten Preisen berechnet, abgerundet) */
  function money(t){ t = (t || '').replace(/[^\d.,]/g, ''); if (!t) return NaN; if (t.indexOf(',') > -1) t = t.replace(/\./g, '').replace(',', '.'); return parseFloat(t); }
  function pct(w){ var p = money((w.querySelector('[data-product-price],.product__price:not(.product__price--compare)') || {}).textContent); var c = money((w.querySelector('[data-compare-price]') || {}).textContent); return (c > p && p > 0) ? Math.floor((c - p) / c * 100) : 0; }
  function saves(){
    document.querySelectorAll('[data-price-wrapper]').forEach(function(w){
      var pe = w.querySelector('.product__price:not(.product__price--compare)'); if (pe && /\d\.\d{2}/.test(pe.textContent)) pe.textContent = pe.textContent.replace(/(\d)\.(\d{2})/, '$1,$2'); var n = pct(w); var b = w.querySelector(':scope > .lp-save');
      if (n >= 1) { if (!b) { b = document.createElement('span'); b.className = 'lp-save'; w.appendChild(b); } if (b.textContent !== '-' + n + '%') b.textContent = '-' + n + '%'; }
      else if (b) b.remove();
      if (!w.dataset.lpObs) { w.dataset.lpObs = 1; new MutationObserver(function(){ saves(); syncSticky(); }).observe(w, { childList: true, subtree: true, characterData: true }); }
    });
  }
  /* Sticky Kaufleiste: erscheint, wenn der Warenkorb-Button nach oben aus dem Bild gescrollt ist */
  function realBtn(){ var f = document.querySelector('form[action*="/cart/add"]'); return f && f.querySelector('[type=submit][name=add]'); }
  function syncSticky(){
    var bar = document.querySelector('[data-lp-sticky]'); var real = realBtn(); if (!bar || !real) return;
    var w = document.querySelector('[data-price-wrapper]'); var out = bar.querySelector('[data-lp-sticky-price]');
    if (w && out) {
      var p = (w.querySelector('[data-product-price],.product__price:not(.product__price--compare)') || {}).textContent || ''; var c = (w.querySelector('[data-compare-price]') || {}).textContent || ''; var n = pct(w);
      var html = p.trim() + (n >= 1 ? '<s>' + c.trim() + '</s><span class="lp-save">-' + n + '%</span>' : '');
      if (out.innerHTML !== html) out.innerHTML = html;
    }
    var btn = bar.querySelector('.lp-sticky-btn'); btn.disabled = real.disabled;
  }
  function sticky(){
    var bar = document.querySelector('[data-lp-sticky]'); var real = realBtn(); if (!bar || !real || bar.dataset.ready) return; bar.dataset.ready = 1;
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    bar.querySelector('.lp-sticky-btn').addEventListener('click', function(){ var r = realBtn(); if (r && !r.disabled) r.click(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ var e = es[0]; bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(real);
    new MutationObserver(syncSticky).observe(real, { attributes: true, attributeFilter: ['disabled'] });
    syncSticky();
  }
  function init(){ bars(); eta(); saves(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
